"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryParams = void 0;
var QueryParams;
(function (QueryParams) {
    QueryParams["DEVICE_CONTEXT"] = "deviceContext";
    QueryParams["REDIRECT_TO"] = "redirect-to";
})(QueryParams || (exports.QueryParams = QueryParams = {}));
//# sourceMappingURL=wellKnownQueryParams.js.map